// eslint-disable-next-line no-unused-vars
export default function parser(json, props) {
  return json.vehicles;
}
